import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavigationUrl } from "../../../../../hooks/useNavigationUrl";
import { ROUTES } from "../../../../../constant";
import { APP_CONFIG, DialogSelected, ENVIRONMENT_TYPE } from "../../../../../constant/common";
import { SELECTED_CHAT_DATA } from "../../../../../constant/dummyData";
import { resolveBoolFlag } from "../../../../../utils/appConfig/resolveBoolFlag";
import { APP_URL, environment } from "../../../../../constant/environment";
import { GA_EVENTS, GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import { StateContext } from "../../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../../context/globalContext/interface";
import { useHistoryContext } from "../../../../../context/historyContext/historyContext";
import { iHistoryContext } from "../../../../../context/historyContext/interface";
import { useRecommendedTripContext } from "../../../../../context/recommendedTripContext/recommendedTripContext";
import { iRecommendedTripContext } from "../../../../../context/recommendedTripContext/recommendedTripContextInterface";
import { iSocketContext, useSocketContext } from "../../../../../context/socketContext/SocketContext";
import { ScreenTypes } from "../../../../../enums";
import { useResetState } from "../../../../../utils/resetBookingData";
import { clearChatBookingOrigin } from "../../../../../utils/booking/clearChatBookingOrigin";
import { consoleLog } from "../../../../../utils/consoleLog/consoleLog";
import { usePixelEvent } from "../../../../../hooks/usePixelEvent";
import { Logoutresponse } from "../../../../../interface";
import { logout } from "../../../../../api/authentication/authentication";
import { handleCustomError } from "../../../../../utils/handleCustomError";
import Cookies from "js-cookie";
import { toastMessage } from "../../../../../helpers/toast/toastMessage";
import { Messages } from "../../../../../constant/messages/toastMessages";
import { getAccessTokenAPI } from "../../../../../api/config/getAccessToken";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { logoutClearStorage } from "../../../../../utils/logoutClearStorage";
import { rotateChatId } from "../../../../../utils/chat/rotateChatId";

const ROUTE_COLORS = {
  [ROUTES.Home]: "#FEFEFE",
  [ROUTES.Booking]: "#FEFEFE",
  [ROUTES.NewTrip]: "#FEFEFE",
  [ROUTES.Today]: "#FEFEFE",
  [ROUTES.TopDestination]: "#FEFEFE",
};

const BOX_SHADOW_DEFAULT = "none";
const BOX_SHADOW_NONE = "none";

export const useCustomSideBarLogic = () => {
  const navigate = useNavigate();
  const { navigateWithParams } = useNavigationUrl();
  const location = useLocation();
  const {
    accessJWT,
    setenableMultiSelect,
    userInfo,
    setSignInClick,
    setMenuOpenState,
    setLoginCreateAccountState,
    screen,
    setScreen,
    setFirstScreen,
    isMobile,
    flightData,
    hotelData,
    activityData,
    setChatInputText,
    setChatData,
    setSelectedChatData,
    setAirPorts,
    setBookClickBeforeLoginFlag,
    setFlightData,
    setHotelData,
    setSelectedHotelRoomArr,
    setBookingDetails,
    setRecentTravelersList,
    setHotelTravelersList,
    setGuestList,
    setShowZoho,
    setSelectedFlightOptions,
    setViewPreference,
    appConfig,
    setIsFetchingMobileAirports,
    setIsValidAccessToken,
    setNav,
    setStartingValue,
    setDestValue,
    setClimate,
    setPopulation,
    setExperience,
    setAccomodations,
    setFoodPreferences,
    setMonths,
    setSelectedDestFlag,
    setTripForNDays,
    setIsLoggedIn,
    setBudget,
    setUserInfo,
    setAccessJWT,
    firstScreen,
    setIsAdminChat,
    isAdminChat,
    setOnBoardingStep,
    setUtmParams,
    promoCode,
    setPromoCode,
    setHideDetails,
    setHasTriggeredPreBooking,
    setActivityData,
    setActivitySearchParams,
    setActivityCartItems,
    setIsActivityReviewPage,
    setShowActivityCollapsedHeader,
  }: iGlobalContext = useContext(StateContext);

  const { resetTranscript } = useSpeechRecognition();
  const [isOpenMobileSidebar, setIsOpenMobileSidebar] = useState<boolean>(false);
  const [isDesktopSidebarExpand, setIsDesktopSidebarExpand] = useState<boolean>(false);
  const [discardOpen, setDiscardOpen] = useState<boolean>(false);

  const { getHistory, currentHistoryId, setCurrentHistoryId }: iHistoryContext = useHistoryContext();
  const { sendPixelEvent } = usePixelEvent();
  const resetState = useResetState();
  const { handleCloseSocketConnection }: iSocketContext = useSocketContext();
  const { handleCancel, setDisableInput }: iRecommendedTripContext = useRecommendedTripContext();
  const isProduction = environment === ENVIRONMENT_TYPE.PRODUCTION;
  const [showGetHelpOptions, setShowGetHelpOptions] = useState<boolean>(false);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (width < 740) {
      setIsOpenMobileSidebar(false);
    } else if (width >= 740 && width < 1200) {
      setIsDesktopSidebarExpand(false);
    } else if (width >= 1200) {
      setIsDesktopSidebarExpand(true);
    }
  }, [width]);

  useEffect(() => {
    if (!isMobile) setIsOpenMobileSidebar(true);
    consoleLog("MOBILE");
  }, [isMobile]);

  const toggleSidebar = () => {
    consoleLog("HELLO");
    if (isMobile) setIsOpenMobileSidebar((prev) => !prev);
    if (!isOpenMobileSidebar) {
      triggerGAEvent(GA_LABEL_ENUMS.home_side_bar_open_click);
      getHistory(true, true);
    } else if (isMobile) {
      triggerGAEvent(GA_LABEL_ENUMS.home_side_bar_close_click);
    }
    if (!isMobile) {
      navigateWithParams(ROUTES.Home);
      return;
    }
  };

  //   const handleLogoClick = () => {
  //     triggerGAEvent(GA_LABEL_ENUMS.home_zenvoya_logo_click);
  //     navigateWithParams(ROUTES.NewTrip);
  //     setIsOpenMobileSidebar(false);
  //     setFirstScreen(ScreenTypes.NewTrip);
  //   };

  const backgroundColor = ROUTE_COLORS[location.pathname] || "#ffff";
  const boxShadow = ROUTE_COLORS[location.pathname] ? BOX_SHADOW_NONE : BOX_SHADOW_DEFAULT;
  const weatherAdvisoryRoutes = [ROUTES.weatherAdvisory, ROUTES.FlightDelay, ROUTES.FlightSelect];
  const isWeatherAdvisory = weatherAdvisoryRoutes.includes(location.pathname);
  const navBarStyles = isWeatherAdvisory ? {} : { backgroundColor, boxShadow };

  function handleSignIn() {
    setSignInClick(true);
    setMenuOpenState(false);
    setLoginCreateAccountState({ flag: true, page: DialogSelected.LOGIN });
    toggleSidebar();
  }

  const handleNav = async () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    triggerGAEvent(GA_LABEL_ENUMS.new_trip_click);
    try {
      handleCloseSocketConnection();
      handleCancel();
      setChatData([]);
      setDisableInput(false);
      setHasTriggeredPreBooking(false);

      // Start a fresh conversation so the backend loads an empty TripContext
      // (else the reused chat id makes a new chat inherit the previous chat's
      // context — e.g. a bare "Hi" re-running the last hotel/flight search).
      rotateChatId();
      setSelectedChatData({ ...SELECTED_CHAT_DATA });

      await resetState();
      setChatInputText("");
      // Clear activity-related state and storage
      setSelectedFlightOptions({ flights: false, hotels: false, activities: false });
      setActivityData(null);
      setActivitySearchParams(null);
      setActivityCartItems([]);
      setIsActivityReviewPage(false);
      setShowActivityCollapsedHeader(false);
      setHideDetails(false);
      try {
        sessionStorage.removeItem("activity_booking_flow_state");
        sessionStorage.removeItem("activity_review_state");
        sessionStorage.removeItem("activity_cart_items");
      } catch {}
      navigateWithParams(ROUTES.Home);
      setScreen("");
      setFirstScreen(ScreenTypes.NewTrip);
    } catch (error) {
      console.error("Error during navigation:", error);
    }
  };

  const handleMobNav = async () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    triggerGAEvent(GA_LABEL_ENUMS.new_trip_click);
    try {
      setChatData([]);
      setDisableInput(false);
      handleCloseSocketConnection();
      handleCancel();
      setChatInputText("");
      setHasTriggeredPreBooking(false);
      // Start a fresh conversation so the backend loads an empty TripContext
      // (see handleNav for the full rationale).
      rotateChatId();
      setSelectedChatData({ ...SELECTED_CHAT_DATA });
      await resetState();
      setenableMultiSelect(false);
      resetState();
      // Clear activity-related state and storage
      setSelectedFlightOptions({ flights: false, hotels: false, activities: false });
      setActivityData(null);
      setActivitySearchParams(null);
      setActivityCartItems([]);
      setIsActivityReviewPage(false);
      setShowActivityCollapsedHeader(false);
      setHideDetails(false);
      try {
        sessionStorage.removeItem("activity_booking_flow_state");
        sessionStorage.removeItem("activity_review_state");
        sessionStorage.removeItem("activity_cart_items");
      } catch {}
      setTimeout(() => navigateWithParams(ROUTES.NewTrip), 100);
      setIsOpenMobileSidebar(false);
    } catch (error) {
      console.error("Error during navigation:", error);
    }
  };

  const performBook = () => {
    triggerGAEvent(GA_LABEL_ENUMS.booking_form_stays_view);

    triggerGAEvent(GA_LABEL_ENUMS.book_without_itinerary_click);
    sendPixelEvent("interactedWithChat", { event: GA_EVENTS[GA_LABEL_ENUMS.book_without_itinerary_click]?.label });
    sendPixelEvent("startChat", { event: GA_EVENTS[GA_LABEL_ENUMS.book_without_itinerary_click]?.label });
    consoleLog(["PIXEL EVENT SESSION START"]);
    setRecentTravelersList([]);
    setHotelTravelersList([]);
    setGuestList([]);
    setAirPorts([]);
    setFlightData(null);
    setHotelData(null);
    setHasTriggeredPreBooking(false);
    setActivityCartItems([]);
    setActivityData(null);
    setActivitySearchParams(null);
    try {
      sessionStorage.removeItem("activity_booking_flow_state");
      sessionStorage.removeItem("activity_review_state");
      sessionStorage.removeItem("activity_cart_items");
    } catch {}
    // Leaving the chat funnel for a fresh Shop Travel (chatless) search — drop the
    // chat-origin markers so search/room-pricing/availability/review go out as v1.
    clearChatBookingOrigin();
    setSelectedFlightOptions({
      flights: false,
      hotels: true,
      activities: false,
    });
    setBookingDetails((prevData) => ({
      ...prevData,
      selectedFlightId: "",
      flightPreferences: {
        connections: null,
        airlines: [],
        refundable: null,
        departureTime: [],
      },
      hotelPreferences: {
        refundable: null,
        hotelChains: [],
        // accommodationTypes: [""],
        accommodationTypes: ["hotel"],
        userRatings: null,
        starRatings: [],
      },
      roomInfo: [
        {
          roomNo: 1,
          adults: 2,
          child: 0,
          childAges: "",
        },
      ],
    }));
    setSelectedHotelRoomArr((prev) =>
      prev.map((hotel) => ({
        ...hotel,
        selectedHotelRoom: null,
      }))
    );
    setSelectedChatData(SELECTED_CHAT_DATA);
    if (isMobile) {
      resetState();
      // Clear any stale firstScreen so a later mobile→desktop resize renders the
      // centered Shop-Travel layout (gated on screen===newBooking && firstScreen==="").
      // Mirrors the desktop branch below; harmless on mobile (firstScreen drives the
      // desktop layout only — DesktopLandingPage early-returns when isMobile).
      // Gated by the middle-panel appConfig flag so MIDDLE_PANEL_ON absent/false matches the old method.
      if (resolveBoolFlag(appConfig, APP_CONFIG.MIDDLE_PANEL_ON)) {
        setFirstScreen("");
      }
      setIsOpenMobileSidebar(false);
      navigateWithParams(ROUTES.BookingInProgress);
    } else {
      // setScreen("");
      setScreen(ScreenTypes.newBooking);
      resetState();
      setSelectedChatData(SELECTED_CHAT_DATA);
      // setFirstScreen(ScreenTypes.newBooking);
      setFirstScreen("");
      if (location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
    setBookClickBeforeLoginFlag(true);
    setTimeout(() => {
      setHideDetails(false);
    }, 200);
  };

  const handleBook = () => {
    const isBookingPanelOpen =
      location.pathname === ROUTES.BookingInProgress ||
      screen === ScreenTypes.newBooking ||
      firstScreen === ScreenTypes.newBooking;
    const hasSearchResults = !!(flightData || hotelData || activityData);

    if (isBookingPanelOpen) {
      if (hasSearchResults) {
        setDiscardOpen(true);
      }
      return;
    }
    performBook();
  };

  const handleDiscardConfirm = () => {
    setDiscardOpen(false);
    triggerGAEvent(GA_LABEL_ENUMS.booking_discard_changes);
    performBook();
  };

  const handleDiscardCancel = () => {
    setDiscardOpen(false);
    triggerGAEvent(GA_LABEL_ENUMS.booking_discard_cancel);
  };

  const handleEditPreference = () => {
    if (!isMobile && firstScreen === ScreenTypes.newPreferences && location.pathname === ROUTES.Home) {
      return;
    }
    if (isMobile && window.location.pathname === ROUTES.preferences) {
      setIsOpenMobileSidebar(false);
      return;
    }
    if (!isMobile) setScreen("");
    isMobile ? navigateWithParams(ROUTES.preferences) : setFirstScreen(ScreenTypes.newPreferences);
    // From a standalone desktop route (e.g. lares /trips) the screen only mounts
    // inside the Home shell — return Home so the preferences screen renders.
    if (!isMobile && location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    triggerGAEvent(GA_LABEL_ENUMS.home_preferences_click);
    // setIsOpenMobileSidebar(false);
    setIsFetchingMobileAirports(true);
    setViewPreference(true);
  };

  const handleMyTrips = () => {
    triggerGAEvent(GA_LABEL_ENUMS.My_trips_click);
    if (isMobile) {
      setIsOpenMobileSidebar(false);
      navigate(ROUTES.MyTrips);
    } else {
      setScreen("");
      setFirstScreen(ScreenTypes.MyTrips);
      // The desktop My Trips screen only renders inside the Home shell
      // (DesktopSelectedScreenPage switches on firstScreen). When the sidebar is
      // shown on a standalone route (e.g. the lares /trips page), setting
      // firstScreen alone changes nothing — return Home so the screen mounts.
      if (location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
  };

  const handleSavedTrip = () => {
    triggerGAEvent(GA_LABEL_ENUMS.saved_trips_click);
    if (isMobile) {
      setIsOpenMobileSidebar(false);
      navigate(ROUTES.SavedTrip);
    } else {
      setScreen("");
      setFirstScreen(ScreenTypes.SavedTrip);
      if (location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
  };
  const handleHistory = () => {
    triggerGAEvent(GA_LABEL_ENUMS.History_click);
    if (isMobile) {
      setIsOpenMobileSidebar(false);
      navigate(ROUTES.History);
    } else {
      setScreen("");
      setFirstScreen(ScreenTypes.History);
      if (location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
  };

  const handleSupport = () => {
    triggerGAEvent(GA_LABEL_ENUMS.sidebar_contact_us);
    if (isMobile) {
      setIsOpenMobileSidebar(false);
    }
    setLoginCreateAccountState({
      flag: true,
      page: DialogSelected.GET_HELP,
    });
  };

  const handlePrivacyPolicy = () => {
    triggerGAEvent(GA_LABEL_ENUMS.Privacy_polcy_click);
    if (isMobile) {
      setIsOpenMobileSidebar(false);
      navigate(ROUTES.PrivacyPolicy);
    } else {
      setScreen("");
      setFirstScreen(ScreenTypes.privacyPolicy);
      if (location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
  };

  const handleTermsAndCondtions = () => {
    triggerGAEvent(GA_LABEL_ENUMS.Terms_of_service_click);
    if (isMobile) {
      setIsOpenMobileSidebar(false);
      navigate(ROUTES.Tos);
    } else {
      setScreen("");
      setFirstScreen(ScreenTypes.termsOfUse);
      if (location.pathname !== ROUTES.Home) navigate(ROUTES.Home);
    }
  };

  function resetStateValues(setters: React.Dispatch<React.SetStateAction<any[]>>[]) {
    setters.forEach((setter) => setter([]));
  }

  function resetAppState() {
    setScreen("");
    setFirstScreen("");
    resetState();
    window.localStorage.removeItem("_zenvoya_JWT");

    const resetUserInfo = {
      id: "",
      name: "",
      email: "",
      phone: "",
      profile_pic: "",
      loggedIn: false,
      role: 0,
    };
    [setUserInfo].forEach((setFunc) => setFunc(resetUserInfo));
    setIsLoggedIn(false);

    setNav("LANDING_PAGE");
    setSelectedDestFlag(false);
    setStartingValue({ value: "", flag: false });
    setDestValue({ value: "", flag: false });

    resetStateValues([
      setClimate,
      setPopulation,
      setExperience,
      setFoodPreferences,
      setAccomodations,
      setMonths,
      setBudget,
      setTripForNDays,
    ]);
  }

  function postLogoutMessage() {
    const iframe = document.querySelector("#app_domain") as HTMLIFrameElement | null;
    const wind = iframe?.contentWindow;
    wind?.postMessage(JSON.stringify({}), "*");

    if (window && window.parent) {
      const message = {
        action: "logout",
        data: {},
      };
      window.parent.postMessage(JSON.stringify(message));
    }
  }

  async function handleLogoutClick() {
    try {
      setIsOpenMobileSidebar(false);
      setOnBoardingStep("lookingFor");
      const nativeElement = document.getElementById("deviceID") as HTMLInputElement | null;
      if (nativeElement?.value) {
        consoleLog(["LOG OUT VALUE", nativeElement?.value]);
        const response: Logoutresponse = await logout(accessJWT, {
          userId: userInfo?.id,
          deviceId: nativeElement?.value ?? "",
        });
        if (response?.statusCode !== 200) {
          handleCustomError(response?.statusCode, "user.logout");
          return null;
        }
      }

      Cookies.remove(`${environment}userData`, {
        path: "/",
        domain: ".zenvoya.ai",
      });
      toastMessage.success(Messages["logout.success"].messageTitle, Messages["logout.success"].message);

      resetAppState();
      logoutClearStorage();

      setUtmParams("");

      navigate(ROUTES.onBoarding);
      setPromoCode([]);
      triggerGAEvent(GA_LABEL_ENUMS.Logout);
      postLogoutMessage();
      setIsValidAccessToken(false);
      await getAccessToken();
    } catch (error) {
      console.error("Error during logout:", error);
      toastMessage.error(Messages["loggout.failure.message"].messageTitle, Messages["loggout.failure.message"].message);
    }
  }

  async function getAccessToken() {
    let success = false;
    let count = 0;
    while (!success) {
      count++;
      const response = await getAccessTokenAPI();
      if (response?.statusCode === 200 && response?.data) {
        setAccessJWT(response?.data);
        success = true;
      }

      if (count > 4) break;
    }
  }

  const handleSelect = (value: string) => {
    switch (value) {
      case "Shop travel":
        handleBook();
        break;
      case "My Trips":
        handleMyTrips();
        break;
      case "Saved Itineraries":
        handleSavedTrip();
        break;
      case "History":
        handleHistory();
        break;
      case "Preferences":
        handleEditPreference();
        break;
      case "Support":
        handleSupport();
        break;
      case "Privacy Policy":
        handlePrivacyPolicy();
        break;
      case "Terms of Service":
        handleTermsAndCondtions();
        break;
      case "Log out":
        handleLogoutClick();
        break;
      default:
        console.warn("Unknown option selected:", value);
    }
  };
  const showNewSideBar = appConfig.find((item) => item.key === "show_new_sidebar")?.value === "true" ? true : false;

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalTop = document.body.style.top;
    const scrollY = window.scrollY;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.top = originalTop;
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    };
  }, []);

  useEffect(() => {
    if (!isOpenMobileSidebar) {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    }
  }, [isOpenMobileSidebar]);

  const handleCopy = () => {
    const text = document.getElementById("copyText")?.innerText || "";
    navigator.clipboard.writeText(`${APP_URL}itinerary?itineraryId=${text}`);
    toastMessage.success("History URL copied", `${APP_URL}itinerary?itineraryId=${text}`);
  };

  return {
    isDesktopSidebarExpand,
    setIsDesktopSidebarExpand,
    isOpenMobileSidebar,
    setIsOpenMobileSidebar,
    navBarStyles,
    toggleSidebar,
    currentHistoryId,
    handleCopy,
    handleNav,
    handleMobNav,
    handleBook,
    discardOpen,
    handleDiscardConfirm,
    handleDiscardCancel,
    promoCode,
    width,
    showNewSideBar,
    userInfo,
    handleSelect,
    firstScreen,
    screen,
    setIsAdminChat,
    isProduction,
    showGetHelpOptions,
    setShowGetHelpOptions,
    handleSignIn,
    handleSupport,
    isMobile,
    ROUTES,
    environment,
    ENVIRONMENT_TYPE,
    setShowZoho,
    setLoginCreateAccountState,
    pathname: location.pathname,
    setCurrentHistoryId,
    isAdminChat,
    handleLogoutClick,
  };
};
